/**
 * Portal Manta · MEFvsMantaTable
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S } from '../../globals.js';

function MEFvsMantaTable({rows, unidadeBase}){
  const fmt = (n)=>{
    if(n==null) return '—';
    if(n===0) return '0';
    return Number(n).toLocaleString('pt-BR',{maximumFractionDigits: n>=100 ? 0 : 1});
  };
  return (<div style={{...S.cardP, padding:0, overflow:'hidden'}}>
    <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
      <thead><tr style={{background:V.g0,borderBottom:'2px solid '+V.g2}}>
        <th style={{padding:'8px 10px',textAlign:'left',fontWeight:700,color:V.g5,fontSize:9.5,letterSpacing:.3,textTransform:'uppercase'}}>Item</th>
        <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.g5,fontSize:9.5}}>Un</th>
        <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.bl,fontSize:9.5}}>MEF</th>
        <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.or,fontSize:9.5}}>Manta</th>
        <th style={{padding:'8px 10px',textAlign:'right',fontWeight:700,color:V.gn,fontSize:9.5}}>Δ%</th>
        <th style={{padding:'8px 10px',textAlign:'left',fontWeight:700,color:V.g5,fontSize:9.5}}>Observação</th>
      </tr></thead>
      <tbody>
        {rows.map((r,i)=>{
          const delta = (r.mef!=null && r.manta!=null && r.mef>0) ? ((r.manta-r.mef)/r.mef*100) : (r.manta>0?100:0);
          const corDelta = delta>0 ? V.or : (delta<0 ? V.gn : V.g4);
          return (<tr key={i} style={{borderBottom:'1px solid '+V.g1}}>
            <td style={{padding:'7px 10px',fontWeight:600,color:V.br}}>{r.item}</td>
            <td style={{padding:'7px 10px',textAlign:'right',color:V.g5,fontFamily:'monospace',fontSize:10}}>{r.un}</td>
            <td style={{padding:'7px 10px',textAlign:'right',color:V.bl,fontFamily:'monospace',fontWeight:600}}>{fmt(r.mef)}</td>
            <td style={{padding:'7px 10px',textAlign:'right',color:V.or,fontFamily:'monospace',fontWeight:600}}>{fmt(r.manta)}</td>
            <td style={{padding:'7px 10px',textAlign:'right',color:corDelta,fontFamily:'monospace',fontSize:10}}>{r.mef===0?'+ novo':`${delta>0?'+':''}${delta.toFixed(0)}%`}</td>
            <td style={{padding:'7px 10px',color:V.g5,fontSize:10,maxWidth:280}}>{r.obs}</td>
          </tr>);
        })}
      </tbody>
    </table>
  </div>);
}

export { MEFvsMantaTable };
export default MEFvsMantaTable;
